import { FunctionComponent } from "react";
import Chip from '@mui/material/Chip';
import { useTranslation } from "next-i18next";

export const FieldSurfaceType: FunctionComponent<{
    type: string
}> = ({
    type,
}) => {
        const { t } = useTranslation('common');
        const typeLabel = (type === "natural") ? t("surfaceTypes.natural") : t("surfaceTypes.synthetic")

        return (
            <Chip
                sx={{
                    mr: 1
                }}
                size="small"
                component="span"
                variant="outlined"
                label={typeLabel}
            ></Chip>
        )
    }